/** @jsx jsx */
import React from "react"

import { Link as GatsbyLink } from "gatsby"
import { useTheme } from "@chakra-ui/react"

import { css, jsx } from "@emotion/react"

export interface GatsbyLinkAsButtonProps {
  /**
   * resize the button based on value provided.
   */
  sizeButton?: string
  href: string
  btnVariant?: string
  bgColorWithHighSaturation?: boolean
}

const GatsbyLinkAsButton: React.FC<GatsbyLinkAsButtonProps> = ({
  sizeButton,
  href,
  btnVariant = "solid",
  children,
}) => {
  // Get chakra ui theme object
  const { colors, lineHeights, fontWeights, fontSizes } = useTheme()
  const {
    components: {
      Button: { variants: themeBtnVariants },
    },
  } = useTheme()

  const {
    components: {
      Button: { defaultProps },
    },
  } = useTheme()

  const theme = useTheme()

  const getVariant = themeBtnVariants[btnVariant](defaultProps)

  const bg = getVariant.bg
    .split(".")
    .reduce((a: { [key: string]: string }, b: string) => a[b], colors)
  const color = getVariant.color
    .split(".")
    .reduce((a: { [key: string]: string }, b: string) => a[b], colors)
  const hoverBg = getVariant._hover.bg
    .split(".")
    .reduce((a: { [key: string]: string }, b: string) => a[b], colors)
  const hoverColor = getVariant._hover.color
    .split(".")
    .reduce((a: { [key: string]: string }, b: string) => a[b], colors)

  const borderColor = getVariant?.borderColor
    ? getVariant?.borderColor
        .split(".")
        .reduce((a: { [key: string]: string }, b: string) => a[b], colors)
    : undefined

  const borderRadius =
    theme.radii[theme?.components?.Button?.baseStyle?.borderRadius] !==
    undefined
      ? theme.radii[theme?.components?.Button?.baseStyle?.borderRadius]
      : theme?.components?.Button?.baseStyle?.borderRadius

  const getPaddingValue = () => {
    switch (sizeButton) {
      case "sm":
        return "6px 8px"
      case "md":
        return "12px 16px"
      case "lg":
        return "16px 32px"
      default:
        return "12px 16px"
    }
  }

  const getFontSize = sizeButton === "sm" ? fontSizes.sm : fontSizes.md

  return (
    <GatsbyLink
      to={href}
      css={css`
        text-decoration: none;
        color: ${color};
        background: ${bg};
        border-style: solid;
        border-color: ${borderColor !== undefined ? `${borderColor}` : "none"};
        border-width: ${borderColor !== undefined ? `1px` : "0px"};
        overflow-wrap: break-word;
        font-weight: ${fontWeights.bold};
        padding: ${getPaddingValue()};
        border-radius: ${borderRadius};
        line-height: ${lineHeights[4]};
        font-size: ${getFontSize};
        transition: all 250ms;
        display: inline-flex;
        align-items: center;
        &:hover {
          text-decocation: none;
          background: ${hoverBg};
          color: ${hoverColor};
          border: ${borderColor !== undefined
            ? `1px solid ${borderColor}`
            : "none"};
        }
      `}
    >
      {children}
    </GatsbyLink>
  )
}

export default GatsbyLinkAsButton
